import Button from "@mui/material/Button";

const ProjectButton = ({
  disabled,
  label,
  onClick,
  startIcon,
}) => (
  <Button
    disabled={disabled}
    onClick={onClick}
    size="small"
    startIcon={startIcon}
    sx={{
      fontSize: "12px",
      my: "auto",
      padding: "1px 8px 1px 8px",
      textTransform: "none",
    }}
    variant="outlined"
  >
    {label}
  </Button>
);

export default ProjectButton;
